"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTS_REDUCER_KEY = exports.reducer = void 0;
const redux_actions_1 = require("redux-actions");
const lodash_1 = require("lodash");
const core_1 = require("companion-app-components/flux/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const actions_1 = require("data/institutionLogins/actions");
const actions = __importStar(require("./actions"));
const constants_1 = require("./constants");
const type_1 = require("./type");
const handleInvestmentAccountMerge = (state, accountsToUpsert) => {
    const [...accountIds] = state.resourcesById.filter((acct) => acct.type === constants_1.ACCOUNT_TYPES.INVESTMENT).keys();
    const accountIdsToUpsert = accountsToUpsert.map((acct) => acct.id);
    const newAccountIds = (accountIds.length === accountIdsToUpsert.length) ? (0, lodash_1.difference)(accountIdsToUpsert, accountIds) : [];
    // isNotSynced is not supported for q17/accounts, desktop clients delete||create investment accounts on un-sync & sync
    // delete local investment accounts on store, if there is any mismatch with q17/accounts response
    const updatedState = (newAccountIds.length > 0 || accountIds.length > accountIdsToUpsert.length) ?
        state.merge({ resourcesById: accountIds.reduce((resourcesById, id) => resourcesById.delete(id), state.resourcesById) }) : state;
    return core_1.resourceUpserters.upsertResources(updatedState, { resources: accountsToUpsert, doMerge: false });
};
// redux-actions types meta as `unknown` regardless of action generic — cast handlers map to allow destructuring
const localReducer = (0, redux_actions_1.handleActions)({
    [actions.getInvestmentAccounts]: (state) => state.merge({ isLoading: true, isInvestmentAccountsLoading: true }),
    [actions.getInvestmentAccountsFailure]: (state, { payload: error }) => core_1.resourceUpserters.completeWithError(state, error).set('isInvestmentAccountsLoading', false),
    [actions.updateInvestmentAccountFailure]: // // optimistic update + undo
    (state, action) => core_1.resourceUndoUpserters.upsertResourceSetupUndo(state, action, accounts_1.accountsActions.updateAccount),
    [(0, redux_actions_1.combineActions)(// optimistic update
    actions.createInvestmentAccount, actions.deleteInvestmentAccount).toString()]: (state, { payload }) => core_1.resourceUpserters.upsertResource(state, payload),
    [actions.batchInvestmentAccounts]: // optimistic update
    (state, { payload }) => core_1.resourceUpserters.upsertResources(state, { resources: payload }),
    [(0, redux_actions_1.combineActions)(actions.createInvestmentAccountFailure, actions.updateInvestmentAccountFailure, actions.deleteInvestmentAccountFailure).toString()]: (state, { payload: error, asyncDispatch }) => {
        asyncDispatch(actions.getInvestmentAccounts());
        return core_1.resourceUpserters.resetResources(state, error);
    },
    [actions_1.deleteInstitutionLoginSuccess]: (state, { asyncDispatch, payload: resource }) => {
        // find and delete all accounts (in REDUX only) that have this institutionLoginId
        let acctsToDelete = state.resourcesById.filter((acct) => acct.institutionLoginId === resource.id);
        if (resource.id && acctsToDelete && acctsToDelete.size > 0) {
            acctsToDelete = acctsToDelete.map((x) => x.set('isDeleted', true));
            acctsToDelete.forEach((acct) => asyncDispatch(accounts_1.accountsActions.deleteAccountSuccess(acct)));
            // asyncDispatch(actions.batchAccountsSuccess(acctsToDelete));
            // give QCS 3seconds to delete the transactions, then do a get
            // note that transactions reducer will not process this as a delete since it went
            // through UPSERT for bulk delete
            // TODO: Listen to batchAccountsSuccess in transactions reducer
            // This is to get impacted transfers from other accts, but does not return actual deleted transactions from account
            // todo: BUMP SERVER
            setTimeout(() => asyncDispatch(transactions_1.transactionsActions.getTransactions()), 3000);
        }
        return state;
    },
    [actions.batchInvestmentAccountsSuccess]: (state, { payload: resources }) => {
        // when ignoring accounts during an Add-FI we had to send to QCS but we not want to add to redux
        const resourcesExcludingIgnored = resources.filter((resource) => !resource.isIgnored);
        const payload = core_1.resourceStoreTypes.mkQcsSyncResourcesPayload({ resources: resourcesExcludingIgnored, doMerge: true });
        return core_1.resourceUpserters.upsertResources(state, payload).set('loadPending', false);
    },
    [(0, redux_actions_1.combineActions)(actions.createInvestmentAccountFailure, actions.updateInvestmentAccountFailure, actions.deleteInvestmentAccountFailure).toString()]: (state, { payload: error, asyncDispatch }) => {
        asyncDispatch(accounts_1.accountsActions.getAccounts());
        return core_1.resourceUpserters.resetResources(state, error);
    },
    [actions.getInvestmentAccountsSuccess]: (state, { payload }) => {
        const accountsToUpsertExcludingIgnored = payload.resources.filter((account) => !account.isIgnored);
        return handleInvestmentAccountMerge(state, accountsToUpsertExcludingIgnored)
            .set('isInvestmentAccountsLoading', false);
    },
    [actions_1.addInstitutionLoginAndAccountsResponse]: {
        next(state, { payload: { accounts }, asyncDispatch }) {
            asyncDispatch(accounts_1.accountsActions.applyAccountsChanges(accounts));
            return state;
        },
    },
}, (0, type_1.AccountsStoreRecord)());
// chain reducers
const reducer = (state, action) => {
    const state1 = localReducer(state, action);
    const state2 = (0, accounts_1.accountsReducer)(state1, action);
    return state2;
};
exports.reducer = reducer;
exports.default = exports.reducer;
exports.ACCOUNTS_REDUCER_KEY = 'accountsStore';
